// алиасы метода из объекта Page

export const getCurrentUser = () => window.WT.Page?.getCurrentUser?.call(window.WT.Page);

export const getTokens = () => window.WT.Page?.getTokens?.call(window.WT.Page);
